import { render, staticRenderFns } from "./PricingDeleteDialog.vue?vue&type=template&id=30538c6c"
import script from "./PricingDeleteDialog.vue?vue&type=script&lang=js"
export * from "./PricingDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports